import { render, staticRenderFns } from "./BaseSuccessDialog.vue?vue&type=template&id=f96de5e8&scoped=true&"
import script from "./BaseSuccessDialog.vue?vue&type=script&lang=js&"
export * from "./BaseSuccessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96de5e8",
  null
  
)

export default component.exports